import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { useEffectOnce } from 'usehooks-ts';

import { healthPlansFetch } from './action';
import { selectFeatureHealthPlan } from './selector';

export const useHealthPlansFetch = () => {
  const dispatch = useDispatch();
  const { healthPlans } = useSelector(selectFeatureHealthPlan);

  useEffectOnce(() => {
    if (!isEmpty(healthPlans)) return;
    dispatch(healthPlansFetch());
  });

  return healthPlans;
};
